import React from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Experiences from './components/Experiences';
import RecentWorks from './components/RecentWorks';
import GetInTouch from './components/GetInTouch';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App font-sans overflow-x-hidden">
      <Navbar />
      <Home />
      <About />
      <Experiences />
      <RecentWorks />
      <GetInTouch />
      <Footer />
    </div>
  );
}

export default App;